export const updateDatiIntermediario = (unDato, actionType) => {
  return {
    type: actionType,
    unDato,
  }
};
